module.exports = __webpack_public_path__ + "static/img/ent-detail-49.83cdf0c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/productspic/entpic/ent-detail-49.jpg
// module id = VOXO
// module chunks = 51